import moment from "moment";
import React, { useCallback, useState } from "react";
import AddIcon from "../../../assets/addIcon.svg";
import ArrowDown from "../../../assets/arrow.svg";
import copyIcon from "../../../assets/copyIcon.svg";
import TrashIcon from "../../../assets/Trash_light.svg";
import { classNames } from "../../../helpers";
import { TwSwitch, TwTimePicker } from "../../../components/tailwind";

const dayLabels = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

const DayTimeSelector = ({
  item,
  onToggleSwitch,
  onTimeChange,
  onTimeRangeCopy,
}) => {
  const [expandDaySelector, setExpandDaySelector] = useState(false);

  const timeString = (openTime) => {
    if (!openTime[0]?.startTime) {
      return "";
    }
    let timeStringVal = `${openTime[0]?.startTime}-${openTime[0]?.endTime}`;
    if (openTime[1]?.startTime) {
      timeStringVal += ` | ${openTime[1]?.startTime}-${openTime[1]?.endTime}`;
    }
    return timeStringVal.toUpperCase();
  };

  const handleTimeChange = (time, type, index) => {
    let openTime = [...item?.openTime];
    openTime.forEach((openTimeObj, timeIndex) => {
      if (timeIndex === index) {
        openTimeObj[type] = moment(time).format("h:mm A");
      }
    });
    onTimeChange(openTime);
  };

  const getNextStartTime = useCallback(() => {
    const lastOpenTime = item?.openTime[item?.openTime.length - 1];
    if (lastOpenTime) {
      const lastEndTime = moment(lastOpenTime.endTime, "h:mm A");
      const nextStartTime = lastEndTime.clone().add(1, "hour").format("h:mm A");
      return nextStartTime;
    }
    return "";
  }, [item?.openTime]);

  const handleTimeRangeChange = (index, action) => {
    let openTime = [...item?.openTime];
    if (action === "add") {
      openTime.push({
        startTime: getNextStartTime(),
        endTime: moment(getNextStartTime(), "h:mm A").add(1, "hour").format("h:mm A"),
      });
    } else {
      openTime.splice(index, 1);
    }
    onTimeChange(openTime);
  };

  return (
    <div className="flex flex-col border-2 border-bright-gray rounded-[10px]">
      <div className="flex flex-row justify-between  items-center px-6 py-4 md:px-11 md:py-6">
        <div className="flex flex-0 items-center">
          <TwSwitch
            checked={item?.isOpen}
            onChange={() => {
              onToggleSwitch(item);
            }}
          />
          {/* <p className="text-xl font-medium text-brown-coffee ml-2">
            {dayLabels[item?.day]}
          </p> */}
        </div>
        <div className="w-full flex flex-1 gap-2 flex-col md:flex-row justify-start md:items-center pl-2">
          <p className="text-base md:text-xl font-medium text-brown-coffee">
            {dayLabels[item?.day]}
          </p>
          {!expandDaySelector && (
            <p className="flex-1 text-xs md:text-base md:text-center">
              {item?.openTime.length > 0
                ? timeString(item?.openTime)
                : "Not Available/closed"}
            </p>
          )}
        </div>
        <div className="flex flex-0 justify-end">
          <img
            src={ArrowDown}
            alt="arrow down"
            className="rotate-90 h-[15px] w-2 cursor-pointer"
            onClick={() => {
              if (item?.openTime?.length > 0) {
                setExpandDaySelector((prev) => !prev);
              }
            }}
          />
        </div>
      </div>
      {expandDaySelector && (
        <div className="flex flex-col gap-2 px-6 md:px-11">
          {item?.openTime?.map((time, index) => {
            console.log("time", time);
            return (
              <div
                className={classNames("w-full flex flex-row items-center gap-2",
                  index !== item?.openTime.length - 1 ? "border-b border-gray-100" : ""
                )}
                key={index}
              >
                <div
                  className="flex flex-col md:flex-row items-center gap-2"
                  style={{ marginBottom: "11px" }}
                  key={index}
                >
                  <TwTimePicker
                    label={"Select Start Time"}
                    value={moment(time?.startTime, "hh:mm A").toDate()}
                    onChange={(date, dateParams) => {
                      const selectedTime = date?.toDate();
                      handleTimeChange(selectedTime, "startTime", index)
                    }}
                  // errors={formErrors}
                  />
                  <span style={{ marginLeft: "23px", marginRight: "23px" }}>
                    to
                  </span>
                  <TwTimePicker
                    label={"Select End Time"}
                    value={moment(time?.endTime, "hh:mm A").toDate()}
                    onChange={(date, dateParams) => {
                      const selectedTime = date?.toDate();
                      handleTimeChange(selectedTime, "endTime", index)
                    }}
                  // errors={formErrors}
                  />
                </div>
                {index === 0 ? (
                  <img
                    src={AddIcon}
                    alt="add icon"
                    className="ml-6 h-5 w-5 cursor-pointer"
                    onClick={() => {
                      handleTimeRangeChange(index, "add");
                    }}
                  />
                ) : (
                  <img
                    src={TrashIcon}
                    alt="delete icon"
                    className="ml-6 h-7 w-7 cursor-pointer"
                    onClick={() => {
                      handleTimeRangeChange(index, "delete");
                    }}
                  />
                )}
              </div>
            );
          })}
          {item?.openTime?.length > 0 && (
            <div className="flex justify-end pr-[9px] pb-4 pt-5">
              <div
                className="flex cursor-pointer"
                onClick={() => {
                  onTimeRangeCopy(item);
                }}
              >
                <img alt="copy icon" src={copyIcon} className="h-5 w-[18px]" />
                <span className="text-base leading-[20px] text-indigo-bz font-light ml-[11px]">
                  Copy this time to all
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default DayTimeSelector;
